<script setup lang="ts">
interface Props {
    rounded?: string
    closable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    rounded: 'lg',
    closable: false
})
</script>

<template>
    <v-alert
        variant="outlined"
        color="red-lighten-3"
        class="text-body-2 pa-5 bg-red-lighten-5"
        role="alert"
        :rounded="props.rounded"
        :closable="props.closable"
    >
        <div class="text-black">
            <slot />
        </div>
    </v-alert>
</template>

<style scoped>

</style>
